//#region Libraries
import styled from "styled-components";
//#endregion

export const Image = styled.img`
    width: 230px;
    margin-top: 35px;
`;